import type { LayoutContextProps, MenuContextProps } from '@/types';
import { createContext } from 'react';

export const LayoutContext = createContext({} as LayoutContextProps);
export const MenuContext = createContext({} as MenuContextProps);
